var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 19",
    fill: "#851A92",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 2.248a8.61 8.61 0 0 1-2.592.755A4.773 4.773 0 0 0 21.393.349a8.724 8.724 0 0 1-2.867 1.164 4.442 4.442 0 0 0-2.56-1.45 4.285 4.285 0 0 0-2.862.505 4.697 4.697 0 0 0-1.983 2.25 5.08 5.08 0 0 0-.286 3.07 12.224 12.224 0 0 1-5.153-1.455A12.994 12.994 0 0 1 1.532.876a5.064 5.064 0 0 0-.494 3.496c.26 1.19.936 2.23 1.892 2.909a4.301 4.301 0 0 1-2.045-.6v.06c0 1.107.361 2.18 1.021 3.038a4.478 4.478 0 0 0 2.6 1.665 4.281 4.281 0 0 1-2.039.082c.288.953.85 1.787 1.606 2.384a4.347 4.347 0 0 0 2.61.948c-1.598 1.334-3.572 2.057-5.605 2.054-.36 0-.72-.023-1.078-.068a12.306 12.306 0 0 0 6.481 2.148 12.227 12.227 0 0 0 6.605-1.667c2.021-1.176 3.707-2.908 4.882-5.015a14.302 14.302 0 0 0 1.778-7.58A9.515 9.515 0 0 0 22 2.248Z"
  })));
};

export default SvgTwitter;